<template>
  <div class="number-component" v-invalid="validation.is_valid">
    <div class="field" v-bind:class="getFieldClass(field.layout.layout_type)">
      <label class="label"
             v-if="field.label && showLabel"
             :class="getLabelClass(field.layout.layout_type)"
             :for="field.id">
        <span>
          {{ field.label }}
        </span>
      </label>
      <div class="control" :class="getControlClass(field.layout.layout_type)">
        <input class="input"
               :class="getInputClass(validation.is_valid)"
               type="number"
               step="1"
               v-model="fieldValue"
               @change="formData.inputOnChange(field)"
               @keyup="removeValidation()"
               :id="field.id"
               :max="field.properties.max_value"
               :min="field.properties.min_value"
               :name="field.id"
               :placeholder="field.properties.placeholder_hint"
               :readonly="field.properties.input_readonly">

        <p class="help is-danger"
           v-if="!validation.is_valid">
          {{ validation.message }}
        </p>
        <p class="help"
           v-if="field.properties.help_text"
           v-html="field.properties.help_text">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'

  export default {
    name: 'number-component',
    props: {
      field: {
        type: FormField
      },
      formData: {
        type: FormData
      },
      showLabel: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      fieldValue: {
        get () {
          return this.formData.fields[this.field.id].value
        },
        set (value) {
          this.formData.fields[this.field.id].value = parseInt(value)
          this.runCallbacks()
        }
      },
      validation () {
        return this.formData.validations[this.field.id] || { is_valid: true }
      }
    },
    methods: {
      runCallbacks () {
        this.formData.callbacks[this.field.id] && this.formData.callbacks[this.field.id](this.field)
      },
      removeValidation () {
        this.validation.is_valid = true
      },
      getFieldClass: function (layoutType) {
        return {
          'columns is-multiline is-mobile': layoutType === 'horizontal'
        }
      },
      getLabelClass: function (layoutType) {
        return {
          'column is-4': layoutType === 'horizontal'
        }
      },
      getControlClass: function (layoutType) {
        return {
          'column is-8': layoutType === 'horizontal'
        }
      },
      getInputClass: function (isValid) {
        return {
          'is-danger': !isValid
        }
      }
    }
  }
</script>

<style lang="sass" scoped>

  label > li
    list-style-position: inside

</style>
